module.exports = __webpack_public_path__ + "img/OTHER.26b625ea.svg";